import environmentSettings from './env/index.json';
import appSettings from './appSettings/index.json';

export const ApiConfig = environmentSettings.api;
export const LoggerConfig = environmentSettings.logger;
export const FileUploadConfig = appSettings.fileUpload;
